/**
 * @generated SignedSource<<2715575fc1335336388813d1ec223910>>
 * @relayHash ff309eb026a43e79cb844a88acc4cc88
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ff309eb026a43e79cb844a88acc4cc88

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SendMessageInput = {
  clientMutationId?: string | null;
  message: string;
  recipientId: string;
};
export type examsSendMessageMutation$variables = {
  input: SendMessageInput;
};
export type examsSendMessageMutation$data = {
  readonly sendMessage: {
    readonly clientMutationId: string | null;
  } | null;
};
export type examsSendMessageMutation = {
  response: examsSendMessageMutation$data;
  variables: examsSendMessageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendMessagePayload",
    "kind": "LinkedField",
    "name": "sendMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "examsSendMessageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "examsSendMessageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ff309eb026a43e79cb844a88acc4cc88",
    "metadata": {},
    "name": "examsSendMessageMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "557123937c90fc64b19e3f275f8f8021";

export default node;
